export default Object.freeze({
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  HAS_SUBSCRIPTION: 'HAS_SUBSCRIPTION',
  ELIGIBLE_NOT_SUBSCRIBED: 'ELIGIBLE_NOT_SUBSCRIBED',
});
